import extend from 'lodash/extend'

// const moduleName = 'page'

// export function transfStyle (params = {}) {
//   let config = cloneDeep(params)
//   if (Array.isArray(config)) {
//     config = arrToPx(config)
//   } else if (Object.prototype.toString.call(config) === '[object Object]') {} {
//     // 如果config是对象 遍历对象
//     for (let prop in config) {
//       if (Array.isArray(config[prop])) {
//         config[prop] = arrToPx(config[prop])
//       }
//       if (typeof config[prop] === 'boolean') {
//         delete config[prop]
//       }
//     }
//   }
//   return config
// }

/**
 * 将配置文件转为可识别css像素
 * @param {*} config 
 * @returns 
 */
export function transfCssUtil (conf = {}) {
  if (Array.isArray(conf)) {
    conf = arrToPx(conf)
  }
  return recursionCss(conf)
  // const temp = recursionCss(conf)
  // return JSON.parse(pxToRem(JSON.stringify(temp)))
}

function recursionCss (conf) {
  let temp = {}
  for (let prop in conf) {
    if (isObj(conf[prop])) {
      temp[prop] = recursionCss(conf[prop])
    } else if (Array.isArray(conf[prop])) {
      temp[prop] = arrToPx(conf[prop])
    } else {
      temp[prop] = conf[prop]
    }
  }
  return temp
}

/**
 * 判断一个值是否为数字或者字符串形式的数字
 * @param {any} value - 需要检查的值
 * @returns {boolean} - 如果是数字或者字符串形式的数字返回 true，否则返回 false
 */
function isNumberOrNumericString (value) {
  // 排除布尔值（虽然布尔值不是数字，但确保严谨性）
  if (typeof value === 'boolean') return false

  // 检查数字类型（排除 NaN）
  if (typeof value === 'number') return !isNaN(value)

  // 检查字符串类型
  if (typeof value === 'string') {
    // 去除首尾空格（按需选择是否需要严格校验）
    const str = value.trim()
    if (!str) return false // 排除空字符串

    // 用正则表达式匹配数字格式：
    // ^[+-]?          => 可选正负号
    // (\d+\.?\d*      => 整数或小数（如 123、123.45）
    // |\.\d+)         => 允许以点开头的小数（如 .45）
    // ([eE][+-]?\d+)? => 科学计数法（如 3e5、-2.7E+10）
    // $               => 确保整个字符串匹配
    return /^[+-]?(\d+\.?\d*|\.\d+)([eE][+-]?\d+)?$/.test(str)
  }

  return false
}

// 数组转可识别像素
export function arrToPx (arr) {
  return arr.map(item => {
    if (isNumberOrNumericString(item)) {
      return `${item}px`
    } 
    return item
  }).join(' ')
}

// pxToRem
export function pxToRem (str, options) {
  const pxRegex = /(\d*\.?\d+)px/ig

  options = extend({
    rootValue: 16,
    unitPrecision: 5,
    minPixelValue: 0
  }, options)

  function createPxReplace(rootValue, unitPrecision, minPixelValue) {
    return function (m, $1) {
      if (m.indexOf('px') === -1) {
        return m
      }
      if (!$1) {
        return m
      }
      let pixels = parseFloat($1)

      if (pixels < minPixelValue) {
        return m
      }
      return toFixed((pixels / rootValue), unitPrecision) + 'rem'
    }
  }

  function toFixed(number, precision) {
    let multiplier = Math.pow(10, precision + 1)
    let wholeNumber = Math.floor(number * multiplier)
    return Math.round(wholeNumber / 10) * 10 / multiplier
  }

  let pxReplace = createPxReplace(options.rootValue, options.unitPrecision, options.minPixelValue)

  return str.replace(pxRegex, pxReplace)
}

function isObj (obj) {
  if (Object.prototype.toString.call(obj) === '[object Object]') {
    return true
  } else {
    return false
  }
}

/**
 * 校验是pc还是移动端
 */
export function isMobile () {
  let flag = false
  let userAgent = navigator.userAgent.toLowerCase()
  if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(userAgent)) {
    flag = true
  }
  return flag
}


function genAOSAnimationAttrs (config) {
  return {
    'data-aos': config.name,
    'data-aos-duration': config.duration,
    'data-aos-delay': config.delay,
    'data-aos-easing': config.easing,
  }
}

export function genAnimationAttrs (options = {}, dataObject) {
  const { lib, enabled, config } = options 
  if (!enabled || !lib || !config) {
    return {}
  }
  let animationAttrs = genAOSAnimationAttrs(config)
  return animationAttrs
  // Object.keys(animationAttrs).forEach(key => {
  //   dataObject.attrs[key] = animationAttrs[key]
  // })
}